// extracted by mini-css-extract-plugin
module.exports = {"hours":"height_hours__bRURu","slussh":"height_slussh__3ds-U","time":"height_time__85tVy","food2":"height_food2__2bWj3","address":"height_address__2DXXW"};